import { Directive, HostBinding, Input, Optional } from '@angular/core';
import { ControlContainer } from '@angular/forms';

@Directive({
  selector: 'label[mbpControlName], span[mbpControlName]',
})
export class LabelControlDirective {
  @Input() mbpControlName: string;

  constructor(@Optional() private parent: ControlContainer) {}

  @HostBinding('textContent')
  get controlValue() {
    return this.parent ? this.parent.control.get(this.mbpControlName).value : '';
  }
}
